export type TriggerMeasurementErrorVariant =
  "rate-limit" | "no-host" | "unknown";

export class TriggerMeasurementError extends Error {
  public readonly variant: TriggerMeasurementErrorVariant;
  public readonly retryAfterSeconds?: number;

  constructor(
    variant: TriggerMeasurementErrorVariant,
    message: string,
    retryAfterSeconds?: number,
  ) {
    super(message);
    this.name = "TriggerMeasurementError";
    this.variant = variant;
    this.retryAfterSeconds = retryAfterSeconds;
  }
}
